import { render } from "./np-preloader.vue?vue&type=template&id=1acc7045"
import script from "./np-preloader.vue?vue&type=script&lang=js"
export * from "./np-preloader.vue?vue&type=script&lang=js"

import "./np-preloader.vue?vue&type=style&index=0&id=1acc7045&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__